var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionBtn2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4458_7845",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4458_7845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3077 22.5017C8.81058 22.5017 8.38502 22.3247 8.03102 21.9707C7.67701 21.6167 7.5 21.1912 7.5 20.694V8.00176H7.25C7.0375 8.00176 6.85938 7.92985 6.71563 7.78604C6.57188 7.64224 6.5 7.46404 6.5 7.25144C6.5 7.03885 6.57188 6.86077 6.71563 6.71719C6.85938 6.57359 7.0375 6.50179 7.25 6.50179H11C11 6.25692 11.0862 6.04827 11.2586 5.87584C11.4311 5.7034 11.6397 5.61719 11.8846 5.61719H16.1154C16.3602 5.61719 16.5689 5.7034 16.7413 5.87584C16.9138 6.04827 17 6.25692 17 6.50179H20.75C20.9625 6.50179 21.1406 6.5737 21.2843 6.71751C21.4281 6.86133 21.5 7.03953 21.5 7.25211C21.5 7.46471 21.4281 7.6428 21.2843 7.78639C21.1406 7.92997 20.9625 8.00176 20.75 8.00176H20.5V20.694C20.5 21.1912 20.3229 21.6167 19.9689 21.9707C19.6149 22.3247 19.1894 22.5017 18.6922 22.5017H9.3077ZM19 8.00176H8.99997V20.694C8.99997 20.7838 9.02883 20.8575 9.08652 20.9152C9.14422 20.9729 9.21795 21.0018 9.3077 21.0018H18.6922C18.782 21.0018 18.8557 20.9729 18.9134 20.9152C18.9711 20.8575 19 20.7838 19 20.694V8.00176ZM12.1542 19.0018C12.3668 19.0018 12.5448 18.9299 12.6884 18.7861C12.832 18.6424 12.9038 18.4643 12.9038 18.2518V10.7517C12.9038 10.5393 12.8319 10.3611 12.6881 10.2174C12.5443 10.0736 12.3661 10.0018 12.1535 10.0018C11.9409 10.0018 11.7628 10.0736 11.6192 10.2174C11.4756 10.3611 11.4039 10.5393 11.4039 10.7517V18.2518C11.4039 18.4643 11.4758 18.6424 11.6196 18.7861C11.7634 18.9299 11.9416 19.0018 12.1542 19.0018ZM15.8464 19.0018C16.059 19.0018 16.2371 18.9299 16.3807 18.7861C16.5243 18.6424 16.5961 18.4643 16.5961 18.2518V10.7517C16.5961 10.5393 16.5242 10.3611 16.3804 10.2174C16.2366 10.0736 16.0584 10.0018 15.8458 10.0018C15.6332 10.0018 15.4551 10.0736 15.3115 10.2174C15.1679 10.3611 15.0961 10.5393 15.0961 10.7517V18.2518C15.0961 18.4643 15.168 18.6424 15.3118 18.7861C15.4557 18.9299 15.6339 19.0018 15.8464 19.0018Z",
    fill: "#35353A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionBtn2);
export default __webpack_public_path__ + "static/media/action-btn2.04f01ffdd371294dcb5637d33c121ab0.svg";
export { ForwardRef as ReactComponent };